<template>
  <div class="page-container">
    <div class="solutions-section">
      <div class="section-container">
        <div class="section-header">
          <h2>全方位的农业数智化解决方案</h2>
          <p>为不同园区、棚型、作物等场景提供专业的智能化产品与服务</p>
        </div>
        <div class="solutions-wrapper">
          <el-row class="solutions-row">
            <el-col class="znjjfa" v-for="(service, index) in services" :key="service.title"
              :class="{ 'last-item': index === services.length - 1 }">
              <div class="solution-card">
                <div class="solution-image-container">
                  <img :src="service.image" class="solution-image" :alt="service.title">
                </div>
                <div class="solution-text-content">
                  <h3 class="solution-title">{{ service.title }}</h3>
                  <div class="ben">
                    <p class="solution-description">{{ service.description }}</p>
                  </div>
                  <el-button type="text" class="smart-button" @click="goToTypicalcase(service.path)">
                    了解详情
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="stats-section">
      <div class="section-container">
        <div class="section-header">
          <h2>用数据说话</h2>
          <p>持续为客户创造价值</p>
        </div>
        <el-row :gutter="24">
          <el-col :span="6" v-for="stat in statistics" :key="stat.label">
            <div class="stat-item">
              <div class="stat-value">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="partners-section">
      <div class="section-container">
        <div class="section-header">
          <h2>合作伙伴</h2>
          <p>携手共创美好未来</p>
        </div>
        <el-row :gutter="24">
          <el-col :span="6" v-for="partner in partners" :key="partner.name" style="padding: 12px;">
            <div class="partner-card">
              <img :src="partner.logo" :alt="partner.name" class="partner-logo"
                :class="{ 'aliyun-logo': partner.name === '阿里云' }">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="contact-section" id="contact-section">
      <div class="section-container">
        <el-row :gutter="24">
          <el-col :span="10">
            <div class="contact-info">
              <h2>联系我们</h2>
              <p class="contact-description" style="margin-top: 40px;">
                如果您有任何问题或建议，请随时与我们联系。我们的专业团队将为您提供最优质的服务。
              </p>
              <div class="contact-details">
                <div class="contact-item">
                  <img :src="addressUrl" alt="地址" class="contact-icon">
                  <span>北京市顺义区赵公路38号院4号楼</span>
                </div>
                <div class="contact-item">
                  <img :src="TelephoneUrl" alt="电话" class="contact-icon">
                  <span>188 1063 9014</span>
                </div>
                <div class="contact-item">
                  <img :src="emailUrl" alt="邮箱" class="contact-icon">
                  <span>liuzhengdao@aiotyzx.com</span>
                </div>
                <div class="section-container">
                  <el-row :gutter="24">
                    <el-col :span="12" v-for="erweima in erweima" :key="erweima.name">
                      <!-- <div class="solution-text-content">
                        <p class="solution-description">{{ erweima.title }}</p>
                      </div> -->
                      <div class="partner-card">
                        <img :src="erweima.logo" :alt="erweima.name" class="partner-logo1"
                          :class="{ 'aliyun-logo': erweima.name === '阿里云' }">
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="contact-info">
              <h2>客户留言板</h2>
              <div class="contact-form-container">
                <iframe :src="formIframeSrc" class="contact-form-iframe" frameborder="0" scrolling="no"></iframe>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainHomepage',
  data() {
    return {

      addressUrl: require('@/assets/images/MainHomepage/address.png'),
      TelephoneUrl: require('@/assets/images/MainHomepage/phone.png'),
      emailUrl: require('@/assets/images/MainHomepage/email.png'),
      formIframeSrc: '',
      statistics: [
        { value: '500+', label: '合作企业' },
        { value: '50000+', label: '服务用户' },
        { value: '99.9%', label: '系统可用性' },
        { value: '24/7', label: '技术支持' }
      ],
      partners: [
        { name: '中国农业大学', logo: require('@/assets/images/MainHomepage/agriculture.png') },
        { name: '西北农业', logo: require('@/assets/images/MainHomepage/西北.jpg') },
        { name: '新疆农科院', logo: require('@/assets/images/MainHomepage/新疆.png') },
        { name: '宁夏大学', logo: require('@/assets/images/MainHomepage/NDschool.png') },
        { name: '阿里云', logo: require('@/assets/images/MainHomepage/aly.png') },
        { name: '简道云', logo: require('@/assets/images/MainHomepage/jdy.png') },
        { name: '移动', logo: require('@/assets/images/MainHomepage/移动.jpg') },

        { name: '嘉立创', logo: require('@/assets/images/MainHomepage/嘉立创.jpg') },

      ],
      erweima: [
        { name: '中国农业大学', title: '公众号', logo: require('@/assets/images/MainHomepage/公众号.png') },
        { name: '宁夏大学', title: '视频号', logo: require('@/assets/images/MainHomepage/视频号.jpg') },
      ],
      services: [
        {
          title: '智能装备',
          description: '融合物联网、自动化技术，助力农业耕种管收精准高效',
          image: require('@/assets/images/MainHomepage/zhnygl.png'),
          path: 'MainHardware'
        },
        {
          title: '数据分析平台',
          description: '基于大数据技术，提供实时数据分析和可视化，助力农业精准决策。',
          image: require('@/assets/images/MainHomepage/ajfxpt.png'),
          path: 'MainSoftware'
        },
        {
          title: '智慧农业管理解决方案',
          description: '通过 AI 和物联网技术，实现农业过程的智能化监控和优化。',
          image: require('@/assets/images/MainHomepage/yjsfw.png'),
          path: 'MainTypicalcase'
        }
      ]
    }
  },
  methods: {
    goToTypicalcase(path) {
      this.$router.push(path);
    }
  },
  mounted() {
    this.formIframeSrc = 'https://rvh2cn0n8t.jiandaoyun.com/f/67e148bcd3627105c1e35659'
  }
}
</script>

<style scoped>
.page-container {
  width: 100%;
  height: 100%;
  background-color: rgba(216, 216, 216, 0.2);
  overflow-x: hidden;
}

.ben {
  height: 50px;
}

.smart-button {
  display: flex;
  align-items: center;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
  font-size: 16px;
  cursor: pointer;
  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: auto;
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-weight: 400;
  font-size: 16px;
  color: #fff;
  width: 112px;
  height: 40px;
  background-color: #2563EB;
  justify-content: center;
  border-radius: 4px;
}

.smart-button:hover {
  color: #1d4ed8;
  background-color: transparent;
  border: 1px solid #2563EB;
}

.section-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.section-header {
  text-align: center;
  margin-bottom: 64px;
}

.section-header h2 {
  text-align: center;
  margin-bottom: 16px;
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 32px;
  font-weight: 600;
  line-height: 36px;
  color: #111827;
}

.section-header p {
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  color: #4B5563;
}

.solutions-section {
  background-color: #f9fafb;
  padding: 96px 0;
  width: 100%;
  box-sizing: border-box;
}

.solutions-wrapper {
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

.solutions-row {
  display: flex;
  flex-wrap: wrap;
  /* width: 100%; */
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  gap: 10px;
}

.znjjfa {
  flex: 1;
  width: 100% !important;
  height: 485px;
  box-sizing: border-box;
}

.znjjfa.last-item {
  margin-right: 0;
}

.solution-card {
  background-color: #ffffff;
  border-radius: 0.5rem;
  padding: 24px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.solution-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.solution-image-container {
  width: 100%;
  height: 12rem;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0;
}

.solution-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.solution-text-content {
  width: 100%;
  padding-left: 0;
  box-sizing: border-box;
  flex-direction: column;
  margin-left: 20px;
}

.solution-title {
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #111827;
  margin-top: 0;
}

.solution-description {
  margin-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  color: #4B5563;
  flex-grow: 1;
}

.details-button {
  display: flex;
  align-items: center;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
  font-size: 16px;
  cursor: pointer;
  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: auto;
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-weight: 400;
  font-size: 16px;
  color: #2563EB;
}

.details-button:hover {
  color: #1d4ed8;
  background-color: transparent;
}

.details-button-icon {
  width: 15px;
  height: 12px;
  margin-left: 8px;
}

.stats-section {
  background-color: #ffffff;
  padding: 96px 0;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 36px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  color: #2563EB;
  margin-bottom: 8px;
}

.stat-label {
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  color: #4B5563;
}

.partners-section {
  background-color: #f9fafb;
  padding: 96px 0;
}

.partner-card {
  background-color: #ffffff;
  border-radius: 0.5rem;
  padding: 24px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
}

.partner-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.partner-logo {
  width: 100%;
  height: 6rem;
  object-fit: contain;
}

.partner-logo1 {
  width: 100%;
  height: 18rem;
  object-fit: contain;
}

.aliyun-logo {
  max-width: 148px;
  margin-left: auto;
  margin-right: auto;
}

.contact-section {
  background-color: #ffffff;
  padding: 96px 0;
}

.contact-info {
  text-align: left;
  padding-right: 24px;
}

.contact-info h2 {
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 30px;
  font-weight: 500;
  line-height: 36px;
  color: #111827;
  margin-bottom: 24px;
  padding: 0 2%;
}

.contact-description {
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  color: #4B5563;
  margin-bottom: 32px;
}

.contact-details {
  text-align: left;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.contact-item:first-child {
  margin-top: 0;
}

.contact-icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
  margin-right: 16px;
}

.contact-item span {
  font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  color: #4B5563;
}

.contact-form-container {
  background-color: #fff;
  border-radius: 0.5rem;
  height: 550px;
  margin-top: 24px;
}

.contact-form-iframe {
  width: 100%;
  height: 100%;
  border-width: 0;
}

.el-button.bg-blue-600 {
  background-color: #2563eb;
  border-color: #2563eb;
}

.el-button.bg-blue-600:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

.el-button.bg-white {
  background-color: #ffffff;
  border-color: #ffffff;
}

.el-button.bg-white:hover {
  background-color: #f3f4f6;
  border-color: #f3f4f6;
}

.el-button.text-blue-600 {
  color: #2563eb;
}

.el-button.text-blue-600:hover {
  color: #1d4ed8;
  background-color: transparent;
}

.custom-input::-webkit-outer-spin-button,
.custom-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.message-board-column {
  display: flex;
  flex-direction: column;
}

/* 手机设备样式 (小于768px) */
@media (max-width: 767px) {

  .solutions-section,
  .stats-section,
  .partners-section,
  .contact-section {
    padding: 60px 0;
  }

  .section-header {
    margin-bottom: 40px;
    padding: 0 15px;
  }

  .section-header h2 {
    font-size: 24px;
    line-height: 32px;
  }

  .section-header p {
    font-size: 16px;
    line-height: 22px;
  }

  .solutions-row {
    flex-wrap: wrap;
  }

  .znjjfa {
    width: 100% !important;
    height: auto;
    margin-bottom: 20px;
  }

  .znjjfa.last-item {
    margin-bottom: 0;
  }

  .solution-image-container {
    height: 10rem;
  }

  .solution-text-content {
    margin-left: 0;
  }

  .solution-title {
    font-size: 18px;
    line-height: 24px;
  }

  .solution-description {
    font-size: 14px;
    line-height: 20px;
  }

  .smart-button {
    width: 100px;
    height: 36px;
    font-size: 14px;
  }

  .stat-item {
    margin-bottom: 30px;
  }

  .stat-value {
    font-size: 28px;
    line-height: 36px;
  }

  .stat-label {
    font-size: 14px;
  }

  .el-row {
    display: flex;
    flex-direction: column;
  }

  .el-col {
    width: 100% !important;
    margin-bottom: 30px !important;
  }

  .el-col:last-child {
    margin-bottom: 0 !important;
  }

  .partner-logo {
    height: 5rem;
  }

  .contact-info {
    padding-right: 0;
  }

  .contact-info h2 {
    font-size: 24px;
  }

  .contact-description {
    font-size: 14px;
  }

  .contact-item span {
    font-size: 14px;
  }

  .contact-form-container {
    height: 500px;
  }
}

/* 平板设备样式 (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .ben {
    height: 80px;
  }

  .solutions-section,
  .stats-section,
  .partners-section,
  .contact-section {
    padding: 70px 0;
  }

  .section-header {
    margin-bottom: 50px;
  }

  .section-header h2 {
    font-size: 28px;
    line-height: 34px;
  }

  .section-header p {
    font-size: 17px;
    line-height: 23px;
  }

  .solutions-row {
    flex-wrap: wrap;
  }

  .znjjfa {
    width: 50% !important;
    height: 450px;
    margin-bottom: 20px;
  }

  .solution-image-container {
    height: 10rem;
  }

  .stat-value {
    font-size: 30px;
  }

  .partner-logo {
    height: 5.5rem;
  }

  .contact-info h2 {
    font-size: 26px;
  }

  .contact-form-container {
    height: 520px;
  }
}

/* 大屏幕设备样式 (2560px - 3839px) */
@media (min-width: 2560px) and (max-width: 3839px) {
  .contact-form-iframe {
    width: 64% !important;
  }

  .section-container {
    max-width: 2400px;
    padding: 0 30px;
  }

  .solutions-section,
  .stats-section,
  .partners-section,
  .contact-section {
    padding: 120px 0;
  }

  .section-header {
    margin-bottom: 80px;
  }

  .section-header h2 {
    font-size: 42px;
    line-height: 48px;
  }

  .section-header p {
    font-size: 24px;
    line-height: 32px;
  }

  .znjjfa {
    height: 580px;
  }

  .solution-card {
    padding: 32px;
  }

  .solution-image-container {
    height: 16rem;
  }

  .solution-title {
    font-size: 26px;
    line-height: 34px;
    margin-bottom: 16px;
  }

  .solution-description {
    font-size: 20px;
    line-height: 28px;
  }

  .smart-button {
    width: 130px;
    height: 48px;
    font-size: 18px;
  }

  .stat-value {
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 12px;
  }

  .stat-label {
    font-size: 20px;
    line-height: 28px;
  }

  .partner-card {
    padding: 32px;
  }

  .partner-logo {
    height: 8rem;
  }

  .aliyun-logo {
    max-width: 200px;
  }

  .contact-info h2 {
    font-size: 36px;
    line-height: 44px;
    margin-bottom: 32px;
    padding: 0 2%;
  }

  .contact-description {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  }

  .contact-icon {
    width: 20px;
    height: 20px;
  }

  .contact-item {
    margin-top: 20px;
  }

  .contact-item span {
    font-size: 20px;
    line-height: 28px;
  }

  .contact-form-container {
    height: 650px;
    margin-top: 32px;
  }
}

/* 超大型屏幕设备样式 (3840px及以上) */
@media (min-width: 3840px) {
  .contact-form-iframe {
    width: 48% !important;
  }

  .section-container {
    max-width: 3200px;
    padding: 0 40px;
  }

  .solutions-section,
  .stats-section,
  .partners-section,
  .contact-section {
    padding: 150px 0;
  }

  .section-header {
    margin-bottom: 100px;
  }

  .section-header h2 {
    font-size: 52px;
    line-height: 60px;
  }

  .section-header p {
    font-size: 30px;
    line-height: 40px;
  }

  .znjjfa {
    height: 680px;
  }

  .solution-card {
    padding: 40px;
  }

  .solution-image-container {
    height: 20rem;
  }

  .solution-title {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 20px;
  }

  .solution-description {
    font-size: 24px;
    line-height: 34px;
  }

  .smart-button {
    width: 150px;
    height: 56px;
    font-size: 22px;
  }

  .stat-value {
    font-size: 60px;
    line-height: 68px;
    margin-bottom: 16px;
  }

  .stat-label {
    font-size: 24px;
    line-height: 32px;
  }

  .partner-card {
    padding: 40px;
  }

  .partner-logo {
    height: 10rem;
  }

  .partner-logo1 {
    height: 25rem;
  }

  .aliyun-logo {
    max-width: 260px;
  }

  .contact-info h2 {
    font-size: 44px;
    line-height: 52px;
    margin-bottom: 40px;
  }

  .contact-description {
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 48px;
  }

  .contact-icon {
    width: 24px;
    height: 24px;
  }

  .contact-item {
    margin-top: 24px;
  }

  .contact-item span {
    font-size: 24px;
    line-height: 34px;
  }

  .contact-form-container {
    height: 750px;
    margin-top: 40px;
  }
}
</style>